import isCdsFrequentPassengerEnabled from './isCdsFrequentPassengerEnabled';
import isCdsFrequentPassengerBootstrapConfirmedAnonymous from './isCdsFrequentPassengerBootstrapConfirmedAnonymous';

/**
 * Whether checkout may offer CDS frequent-passenger enrollment to this shopper.
 * Reserhub Account is the new CDS session source; the legacy session remains in use
 * during the transition, so both must be checked.
 * @param {object} options
 * @param {object} options.features
 * @param {string} options.brand
 * @param {object} options.cdsSession
 * @param {object|null} options.reserhubUser
 * @param {boolean} options.isReserhubUserLoading
 * @param {boolean} options.isReserhubUserFetched
 * @param {boolean} options.isReserhubUserAnonymous
 * @returns {boolean}
 */
export default function isCdsFrequentPassengerOptInEligible({
  features,
  brand,
  cdsSession,
  reserhubUser,
  isReserhubUserLoading = false,
  isReserhubUserFetched = false,
  isReserhubUserAnonymous = false,
}) {
  const legacySessionEligible =
    isCdsFrequentPassengerEnabled(features, brand) &&
    !reserhubUser &&
    isCdsFrequentPassengerBootstrapConfirmedAnonymous(cdsSession);

  if (!legacySessionEligible || !cdsSession?.usesReserhubAccount) return legacySessionEligible;

  return isReserhubUserFetched && !isReserhubUserLoading && isReserhubUserAnonymous;
}
